export enum UserType {
    PERSONAL = "PERSONAL",
    MANAGED = "MANAGED",
}
export enum Role {
    USER = "USER",
    MODERATOR = "MODERATOR",
    ADMIN = "ADMIN",
    SUPER_USER = "SUPER_USER",
}

export enum AccountType {
    CLIENT = "CLIENT",
    DISTRIBUTOR = "DISTRIBUTOR",
    EYEVIATION = "EYEVIATION",
}

